module.exports = __webpack_public_path__ + "faq/img/active.02fa8ccf.png";